export const TOGGLE_VIDEO_GRID = 'TOGGLE_VIDEO_GRID';
export type ToggleVideoGridAction = {
  type: typeof TOGGLE_VIDEO_GRID;
};
export function toggleVideoGridAction(): ToggleVideoGridAction {
  return {
    type: TOGGLE_VIDEO_GRID
  };
}